import { Box, Typography } from "@mui/material";
import "./_style.scss";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import {
  childcareLeaveTableHead,
  headListWorkingDayNum,
  fakeTableList,
  salaryTableHead,
  schema,
} from "./parts";
import { useContext, useEffect, useState, useRef } from "react";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkButton from "../../components/atoms/TkButton";
import TkTable from "../../components/atoms/TkTable";
import { useLocation, useNavigate } from "react-router-dom";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  applyEvent,
  ApplicationStatus,
  FormClassRetire,
  FormKbn,
  HalfYearExtensionReason,
  PapaMamaPlus,
  Prefectures,
  RetireFlowReason,
  RetireReason,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { httpAPI_STA003, httpAPI_APP016 } from "./api/request";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import _ from "lodash";
import { changeZipcodeFormat } from "../../utils/useTools";
import { ChildcareActiveListList } from "../../type/contextType/businessContext/IJob_32";

/**
 * SCRW060005_退職情報　登録（登録内容の確認）
 * @return SCRW060005_退職情報　登録（登録内容の確認）
 */
const SCRW060005 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);

  // ユーザタイプ
  const userType = state.authInfo?.userType;
  // ユーザタイプが機構か
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;

  const [stateInfoList, setStateInfoList] = useState<any>([]);

  // 育休状況
  const [childcareLeaveBodyList, setChildcareLeaveBodyList] = useState<any>();
  const [childcareLeaveWorkingDayNumList, setChildcareLeaveWorkingDayNumList] =
    useState<any>();
  // 本俸月額登録
  const [salaryTableList, setSalaryTableList] = useState<any>([]);

  // 法人申請区分
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>();
  // 法人申請区分
  const [latestApplyStatus, setLatestApplyStatus] = useState<string>();
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    let resArr = stateFakeTableList.current;

    try {
      const res = await httpAPI_STA003({
        contractorNo: businessState.common?.contractorNo,
        staffNo: businessState.job_32?.staffNo,
        applyId: location.state?.applyId ?? businessState.job_32?.applyId,
      });

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.setDefaultValue = res[i as keyof typeof res]);
          targetObj && (targetObj.text = res[i as keyof typeof res]);
        }
        // 法人申請区分
        setCorpApplyKbn(res.corpApplyKbn as keyof typeof corpApplyKbn);
        // 最新申請状態
        setLatestApplyStatus(res.latestApplyStatus);
        // 退職理由
        const nRetireReasonCdText = TkGetCode(
          RetireReason,
          res.nRetireReasonCd
        );
        // 退職者名（新）
        const staffNameKanjiInput = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        // 退職者名カナ（新）
        const staffNameKanaInput = resArr.find(
          (item) => item.keyword === "staffNameKana"
        )!;
        // 退職者名漢字
        const bNameKanjiInput = resArr.find(
          (item) => item.keyword === "bNameKanji"
        )!;
        // 退職者名カナ
        const bNameKanaInput = resArr.find(
          (item) => item.keyword === "bNameKana"
        )!;

        if (res?.bNameKanji) {
          staffNameKanjiInput.text = res?.staffNameKanji;
          bNameKanjiInput.text = res?.bNameKanji;
        } else {
          staffNameKanjiInput.showLine = false;
          bNameKanjiInput.text = res?.staffNameKanji;
        }

        if (res?.bNameKana) {
          staffNameKanaInput.text = res?.staffNameKana;
          bNameKanaInput.text = res?.bNameKana;
        } else {
          staffNameKanaInput.showLine = false;
          bNameKanaInput.text = res?.staffNameKana;
        }
        let nRetireReasonCd = resArr.find(
          (item) => item.keyword === "nRetireReasonCd"
        )!;
        nRetireReasonCd.text = nRetireReasonCdText;

        resArr.find((item) => item.keyword === "retireProcedureReason")!.text =
          TkGetCode(RetireFlowReason, res.retireProcedureReason);

        let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
        zipcode.text = changeZipcodeFormat(res.zipcode);

        // 退職者住所
        let address = resArr.find((item) => item.keyword === "address")!;
        if (
          res?.prefectureCd !== "" &&
          res?.prefectureCd !== undefined &&
          res?.addressCity !== "" &&
          res?.addressCity !== undefined &&
          res?.addressOthers !== "" &&
          res?.addressOthers !== undefined
        ) {
          address.text = `${TkGetCode(Prefectures, res?.prefectureCd)}${
            res?.addressCity
          }${res?.addressOthers}`;
        }
        // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
        let continueTransferApplicable1Flg = resArr.find(
          (item) => item.keyword === "continueTransferApplicable1Flg"
        )!;
        continueTransferApplicable1Flg.text =
          !res?.continueTransferApplicable1Flg ||
          res?.continueTransferApplicable1Flg === "" ||
          res?.continueTransferApplicable1Flg === "0"
            ? ""
            : "該当";
        // 現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である
        let continueTransferApplicable2Flg = resArr.find(
          (item) => item.keyword === "continueTransferApplicable2Flg"
        )!;
        continueTransferApplicable2Flg.text =
          !res?.continueTransferApplicable2Flg ||
          res?.continueTransferApplicable2Flg === "" ||
          res?.continueTransferApplicable2Flg === "0"
            ? ""
            : "該当";

        // ならない月
        let notToBeMonth = resArr.find(
          (item) => item.keyword === "notToBeMonth"
        )!;
        let checkedList = notToBeMonth.checkBoxList
          ?.filter((item) =>
            ["1", "3"].includes(res[item.value as keyof typeof res] as string)
          )
          .map((item) => item.label);
        notToBeMonth.setDefaultValue = checkedList?.length
          ? checkedList
          : ["無"];

        // 退職月の出勤日数
        let retireWorkingDayNum = resArr.find(
          (item) => item.keyword === "retireWorkingDayNum"
        )!;
        retireWorkingDayNum.text = (res.workingDayNum ?? 0) + "日";
        // 共済契約者番号
        let contractorNo = resArr.find(
          (item) => item.keyword === "aContractorNo"
        )!;
        contractorNo.text = res?.aContractorNo;
        // 共済契約者氏名
        let contractorName = resArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        contractorName.text = res?.aCorpName;
        // 賃金台帳(ファイルがあれば)
        const wagesFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["退職書類"] &&
            item.formClass === FormClassRetire["賃金台帳"]
        );

        if (wagesFile) {
          let wages = resArr.find((item) => item.keyword === "wages")!;
          wages.base64filedata = wagesFile.fileBase64;
          wages.dataname = wagesFile.formName;

          wages.showLine = true;
        }

        // 雇用契約書(ファイルがあれば)
        const contractEmploymentFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["退職書類"] &&
            item.formClass === FormClassRetire["雇用契約書"]
        );

        if (contractEmploymentFile) {
          let contractEmployment = resArr.find(
            (item) => item.keyword === "contractEmployment"
          )!;

          contractEmployment.dataname = contractEmploymentFile.formName;
          contractEmployment.base64filedata = contractEmploymentFile.fileBase64;

          contractEmployment.showLine = true;
        }

        // 育休状況
        const bodyListChildcareLeave = res?.childcareLeaveList?.map(
          (item: any) => [
            {
              children: item.childcareLeaveSerialNo,
            },
            {
              children: item.birthday,
              align: "center",
            },
            {
              children: item.startDate,
              align: "center",
            },
            {
              children: item.endDate,
              align: "center",
            },
            {
              children: TkGetCode(PapaMamaPlus, item.papaMamaFlg),
              align: "center",
            },
            {
              children: TkGetCode(
                HalfYearExtensionReason,
                item.halfyearExtensionReason
              ),
            },
            {
              children: item.papaChildcareLeaveFlg === "1" ? "有" : "無",
              align: "center",
            },
          ]
        );
        setChildcareLeaveBodyList(bodyListChildcareLeave);
        const childcareActiveListList =
          res.childcareLeaveWorkingDayNumList?.map(
            (item: ChildcareActiveListList) => [
              {
                children: `${(item.yearMonth + "").slice(0, 4)}/${(
                  item.yearMonth + ""
                ).slice(4)}`,
                align: "center",
              },
              {
                children: `${item.workingDayNum?.toString()}日`, // 出勤日数
                align: "right",
              },
            ]
          );
        setChildcareLeaveWorkingDayNumList(childcareActiveListList);

        // 本俸月額登録
        const salaryList = res.sixMonthsSalaryBeforeApplyList?.map(
          (item: any) => [
            {
              children: `${
                item.yearMonth ? item.yearMonth.toString().slice(0, 4) : ""
              }/${item.yearMonth ? item.yearMonth.toString().slice(4, 6) : ""}`,
              align: "center",
            },
            {
              children: `${item.salaryTableAmt.toLocaleString()}円`,
              align: "right",
            },
            {
              children: `${item.salaryAdjustmentAmt.toLocaleString()}円`,
              align: "right",
            },
          ]
        );
        setSalaryTableList(salaryList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      console.log(error);
      navigate("/error");
    }

    setStateInfoList([...resArr]);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    applyEvent: any,
    validate: boolean,
    formData?: any
  ) => {
    // 申請状況更新API実行
    try {
      const res = await httpAPI_APP016({
        applyId: location.state?.applyId ?? businessState.job_32?.applyId,
        applyEvent: applyEvent,
        contractorNo: businessState.common?.contractorNo,
        reason: undefined,
        inquiryCode: undefined,
        symbolNo: undefined,
        decisionDate: undefined,
        screenId: "SCRW060004",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOpenDialogOrSubmit = (value: keyof typeof applyEvent) => {
    let event = applyEvent[value];
    switch (event) {
      case applyEvent["取下げ"]:
        handleSubmit(event, false);
        break;
    }
  };

  return (
    <Box data-testid="SCRW060005PageForTest" className="SCRW060005">
      <TkKikoStepper
        applicationStatus={latestApplyStatus as keyof typeof ApplicationStatus}
        applicationFlowType={"TYPE4"}
        businessType={"JOB-33"}
        corporateApplicationClassification={corpApplyKbn}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW060005_01}</TkInfoManual>
      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            (businessState.common?.contractorNo ?? "") +
            ":" +
            (businessState.common?.contractorName ?? "")
          }
        />
      )}
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schema}
        showButton={false}
      />
      <Typography className="tableTitle">育休状況</Typography>
      <TkTable
        headList={childcareLeaveTableHead}
        bodyList={childcareLeaveBodyList}
      />
      <TkTable
        headList={headListWorkingDayNum}
        bodyList={childcareLeaveWorkingDayNumList}
      />
      <Typography className="tableTitle">本俸月額登録</Typography>
      <TkTable headList={salaryTableHead} bodyList={salaryTableList} />
      <Box className="button">
        <TkBackButton />
        <TkViewButtonJudgement
          flowType="TYPE4"
          Status={latestApplyStatus as ITkViewButtonJudgementStatus}
          onClick={handleOpenDialogOrSubmit}
        />
        {(latestApplyStatus === Status["受理待ち"] ||
          latestApplyStatus === Status["再受理待ち"] ||
          latestApplyStatus === Status["稟議決裁結果待ち"] ||
          latestApplyStatus === Status["課長代理確認待ち"] ||
          latestApplyStatus === Status["上長承認待ち"] ||
          latestApplyStatus === Status["郵送待ち"] ||
          latestApplyStatus === Status["処理完了"]) && (
          <TkButton onClick={() => handleOpenDialogOrSubmit("取下げ")}>
            取下げ
          </TkButton>
        )}
      </Box>
    </Box>
  );
};

export default SCRW060005;
